/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.endDate = this.getCETDate(this.dataset.date).getTime();
      this.timer = null;
    }

    connectedCallback() {
      this.updateCountdown();
      this.timer = setInterval(() => this.updateCountdown(), 1000);
    }

    disconnectedCallback() {
      if (this.timer) {
        clearInterval(this.timer);
      }
    }

    getCETDate(dateString) {
      const [datePart, timePart] = dateString.split(' ');
      const [month, day, year] = datePart.split('-');
      const [hours, minutes, seconds] = timePart.split(':');

      // Create a date in UTC, considering it as CET
      const utcDate = new Date(Date.UTC(year, month - 1, day, hours, minutes, seconds));

      // Adjust for CET (UTC+1 in winter, UTC+2 in summer)
      const cetOffset = this.isCETDaylightSaving(utcDate) ? 2 : 1;
      utcDate.setUTCHours(utcDate.getUTCHours() - cetOffset);

      return utcDate;
    }

    isCETDaylightSaving(date) {
      const dstStart = new Date(date.getUTCFullYear(), 2, 31 - (5 * Math.floor(date.getUTCFullYear() / 4 + 4) % 7));
      const dstEnd = new Date(date.getUTCFullYear(), 9, 31 - (5 * Math.floor(date.getUTCFullYear() / 4 + 1) % 7));
      return date >= dstStart && date < dstEnd;
    }

    updateCountdown() {
      const now = new Date().getTime();
      const distance = this.endDate - now;

      if (distance < 0) {
        this.innerHTML = "EXPIRED";
        clearInterval(this.timer);
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      this.innerHTML = `
        <span class="countdown__item">${days.toString().padStart(2, '0')}</span> :
        <span class="countdown__item">${hours.toString().padStart(2, '0')}</span> :
        <span class="countdown__item">${minutes.toString().padStart(2, '0')}</span> :
        <span class="countdown__item">${seconds.toString().padStart(2, '0')}</span>
      `;
    }
  }

  customElements.define('countdown-timer2', CountdownTimer);

  document.addEventListener('theme:variant:change', (event) => {
    if (event.detail.quickAdd) {
      const { variant, quickAdd } = event.detail;

      if (variant?.options.length == 1) {
        quickAdd.querySelector('.quickadd-btn').click();
      }
    }
  });

  class ToggleText extends HTMLElement {
    constructor() {
      super();

      this.defaultText = this.querySelector('.toggle-text__default');
      this.modelSize = this.querySelector('.toggle-text__model-size');
      this.closeButton = this.querySelector('.toggle-text__close');

      this.addEventListener('click', this.handleClick.bind(this));
      this.closeButton.addEventListener('click', this.handleClose.bind(this));
    }

    handleClick(event) {
      // Prevent firing both click handlers when close button is clicked
      if (event.target === this.closeButton) return;

      this.defaultText.classList.add('hidden');
      this.modelSize.classList.remove('hidden');
      this.closeButton.classList.remove('hidden');
    }

    handleClose(event) {
      event.stopPropagation();

      this.defaultText.classList.remove('hidden');
      this.modelSize.classList.add('hidden');
      this.closeButton.classList.add('hidden');
    }
  }

  // Define the custom element
  if (!customElements.get('toggle-text')) {
    customElements.define('toggle-text', ToggleText);
  }




  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();



document.querySelector(".checklist-end-arrow")?.addEventListener("click", function() {
  const currentSection = this.closest('.shopify-section');
  const nextSection = currentSection.nextElementSibling;

  if (nextSection) {
    nextSection.scrollIntoView({ behavior: 'smooth' });
  }
});

// Function to set quick-add height for a single product item
function setQuickAddHeight(productItem) {
  const quickAddHolder = productItem.querySelector('.quick-add__holder');

  if (quickAddHolder) {
    // Get the computed height of the quick-add holder
    const height = quickAddHolder.getBoundingClientRect().height;
    // Set the custom property on the product item
    productItem.style.setProperty('--quickadd-height', `${height}px`);
  }
}

// Function to handle all product items
function updateAllQuickAddHeights() {
  const productItems = document.querySelectorAll('.product-item__image');
  productItems.forEach(setQuickAddHeight);
}

// Initial setup
updateAllQuickAddHeights();

// Update heights on window resize
window.addEventListener('resize', updateAllQuickAddHeights);
document.addEventListener('wishlist:load', updateAllQuickAddHeights);


const selectors$108 = {
  aos: '[data-aos]:not(.aos-animate)',
  aosAnchor: '[data-aos-anchor]',
};

const classes$E = {
  aosAnimate: 'aos-animate',
};

const observerConfig = {
  attributes: false,
  childList: true,
  subtree: true,
};

const mutationCallback = (mutationList) => {
  for (const mutation of mutationList) {
    if (mutation.type === 'childList') {
      const element = mutation.target;
      const elementsToAnimate = element.querySelectorAll(selectors$108.aos);
      const anchors = element.querySelectorAll(selectors$108.aosAnchor);

      if (elementsToAnimate.length) {
        elementsToAnimate.forEach((element) => {
          aosItemObserver.observe(element);
        });
      }

      if (anchors.length) {
        // Get all anchors and attach observers
        initAnchorObservers(anchors);
      }
    }
  }
};

/*
  Observe each element that needs to be animated
*/
const aosItemObserver = new IntersectionObserver(
  (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add(classes$E.aosAnimate);

        // Stop observing element after it was animated
        observer.unobserve(entry.target);
      }
    });
  },
  {
    root: null,
    rootMargin: '0px',
    threshold: [0, 0.1, 0.25, 0.5, 0.75, 1],
  }
);

/*
  Observe anchor elements
*/
const aosAnchorObserver = new IntersectionObserver(
  (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.intersectionRatio > 0.1) {
        const elementsToAnimate = entry.target.querySelectorAll(selectors$108.aos);

        if (elementsToAnimate.length) {
          elementsToAnimate.forEach((item) => {
            item.classList.add(classes$E.aosAnimate);
          });
        }

        // Stop observing anchor element after inner elements were animated
        observer.unobserve(entry.target);
      }
    });
  },
  {
    root: null,
    rootMargin: '0px',
    threshold: [0.1, 0.25, 0.5, 0.75, 1],
  }
);

/*
  Watch for mutations in the body and start observing the newly added animated elements and anchors
*/
function bodyMutationObserver() {
  const bodyObserver = new MutationObserver(mutationCallback);
  bodyObserver.observe(document.body, observerConfig);
}

/*
  Observe animated elements that have attribute [data-aos]
*/
function elementsIntersectionObserver() {
  const elementsToAnimate = document.querySelectorAll(selectors$108.aos);

  if (elementsToAnimate.length) {
    elementsToAnimate.forEach((element) => {
      aosItemObserver.observe(element);
    });
  }
}

/*
  Observe animated elements that have attribute [data-aos]
*/
function anchorsIntersectionObserver() {
  const anchors = document.querySelectorAll(selectors$108.aosAnchor);

  if (anchors.length) {
    // Get all anchors and attach observers
    initAnchorObservers(anchors);
  }
}

function initAnchorObservers(anchors) {
  let anchorContainers = [];

  if (!anchors.length) return;

  anchors.forEach((anchor) => {
    const containerId = anchor.dataset.aosAnchor;

    // Avoid adding multiple observers to the same element
    if (containerId && anchorContainers.indexOf(containerId) === -1) {
      const container = document.querySelector(containerId);

      if (container) {
        aosAnchorObserver.observe(container);
        anchorContainers.push(containerId);
      }
    }
  });
}

function initAnimations() {
  elementsIntersectionObserver();
  anchorsIntersectionObserver();
  bodyMutationObserver();
}

if (window.theme.settings.enableAnimations) {
  initAnimations();
}

class CartDiscount extends HTMLElement {
  constructor() {
    super();
    // Enable debug mode based on URL param or localStorage
    this.debugMode = true;

    this.perfMetrics = {};

    this.form = this.querySelector('[data-discount-form]');
    this.input = this.querySelector('[data-discount-input]');
    this.submitButton = this.querySelector('[data-discount-submit]');
    this.messageEl = this.querySelector('[data-discount-message]');
    this.appliedContainer = this.querySelector('[data-discount-applied]');
    this.valueEl = this.querySelector('[data-discount-value]');
    this.removeButton = this.querySelector('[data-discount-remove]');

    this.cartState = this.initializeCartState();
    this.isSubmitting = false;
    this.lastAppliedCode = null;

    // this.debug('Component initialized', { initialCartState: this.cartState });

    this.bindEvents();
    this.checkForExistingDiscount();
    this.checkUrlAndRestoreDiscount();
  }

  // Debug utilities
  startTimer(label) {
    if (!this.debugMode) return;
    this.perfMetrics[label] = {
      start: performance.now(),
      end: null,
      duration: null
    };
  }

  endTimer(label) {
    if (!this.debugMode) return;
    if (this.perfMetrics[label]) {
      this.perfMetrics[label].end = performance.now();
      this.perfMetrics[label].duration = this.perfMetrics[label].end - this.perfMetrics[label].start;
      // this.debug(`${label} completed`, {
      //   duration: `${this.perfMetrics[label].duration.toFixed(2)}ms`,
      //   metrics: this.perfMetrics[label]
      // });
    }
  }

  debug(message, data = {}) {
    if (!this.debugMode) return;
    console.group(`🛒 CartDiscount: ${message}`);
    if (Object.keys(data).length) {
      Object.entries(data).forEach(([key, value]) => {
        console.log(`${key}:`, value);
      });
    }
    console.groupEnd();
  }
  bindEvents() {
    this.form.addEventListener('submit', this.handleSubmit.bind(this));
    this.removeButton?.addEventListener('click', this.handleRemove.bind(this));

    // Listen for cart updates from other components
    window.addEventListener('cart:updated', this.handleCartUpdate.bind(this));
  }

  handleCartUpdate(event) {
    if (event.detail?.cart) {
      this.cartState = event.detail.cart;
    }
  }

  initializeCartState() {
    this.startTimer('initializeCartState');
    try {
      const cartData = this.getAttribute('data-cart');
      const parsed = cartData ? JSON.parse(cartData) : null;
      // this.debug('Cart state initialized', { cartData: parsed });
      return parsed;
    } catch (error) {
      // this.debug('Cart state initialization failed', { error });
      return null;
    } finally {
      this.endTimer('initializeCartState');
    }
  }

  async handleSubmit(event) {
    event.preventDefault();
    this.startTimer('handleSubmit');

    if (this.isSubmitting) return;

    const code = this.input.value.trim();
    if (!code) return;

    // this.debug('Starting discount submission', { code });

    this.startTimer('checkExistingDiscount');
    const hasExistingDiscount = this.hasAppliedDiscount(this.cartState);
    this.endTimer('checkExistingDiscount');

    if (hasExistingDiscount) {
      this.startTimer('confirmDialog');
      const confirmReplace = await this.showConfirmDialog(
        'This will replace your current discount. Continue?'
      );
      this.endTimer('confirmDialog');

      if (!confirmReplace) {
        // this.debug('Discount replacement cancelled by user');
        return;
      }
      this.clearDiscount();
    }

    this.isSubmitting = true;
    this.setLoading(true);
    this.clearMessage();

    try {
      this.startTimer('applyDiscount');
      const encodedCode = encodeURIComponent(code);
      const discountResponse = await fetch(`/discount/${encodedCode}`);
      this.endTimer('applyDiscount');

      if (!discountResponse.ok) {
        throw new Error(`Failed to apply discount: ${discountResponse.statusText}`);
      }

      this.startTimer('fetchUpdatedCart');
      const updatedCart = await this.getCart();
      this.cartState = updatedCart;
      this.endTimer('fetchUpdatedCart');

      this.startTimer('processDiscount');
      const appliedDiscount = this.findAppliedDiscount(updatedCart, code);

      if (appliedDiscount) {
        const totalDiscountAmount = this.calculateTotalDiscount(updatedCart, code);
        this.showSuccess({
          title: appliedDiscount.title,
          amount: totalDiscountAmount
        });
        this.input.value = '';
        this.lastAppliedCode = code;

        window.cart.getCart();
        // this.debug('Discount code applied successfully', {
        //   discount: appliedDiscount,
        //   amount: totalDiscountAmount
        // });
      } else {
        this.showError('Unfortunately, the discount code cannot be used');
        // this.debug('Discount not found after application');
      }
      this.endTimer('processDiscount');

    } catch (error) {
      // this.debug('Error applying discount', { error });
      // console.error('Discount error:', error);
      this.showError(this.getErrorMessage(error));
    } finally {
      this.isSubmitting = false;
      this.setLoading(false);

      if (this.debugMode) {
        console.group('🛒 CartDiscount: Performance Summary');
        Object.entries(this.perfMetrics)
          .sort((a, b) => (b[1].duration || 0) - (a[1].duration || 0))
          .forEach(([label, metrics]) => {
            if (metrics.duration) {
              // console.log(`${label}: ${metrics.duration.toFixed(2)}ms`);
            }
          });
        console.groupEnd();
      }

      this.endTimer('handleSubmit');
    }
  }

  hasAppliedDiscount(cart) {
    if (!cart) return false;
    return cart.cart_level_discount_applications?.length > 0 ||
           cart.items?.some(item => item.line_level_discount_allocations?.length > 0);
  }

  findAppliedDiscount(cart, code) {
    if (!cart) return null;
    const normalizedCode = code.toLowerCase();

    const cartDiscount = cart.cart_level_discount_applications?.find(
      discount => discount.type === 'discount_code' &&
                 discount.title.toLowerCase() === normalizedCode
    );

    if (cartDiscount) return cartDiscount;

    for (const item of cart.items || []) {
      const lineDiscount = item.line_level_discount_allocations?.find(
        allocation => allocation.discount_application.type === 'discount_code' &&
                     allocation.discount_application.title.toLowerCase() === normalizedCode
      );
      if (lineDiscount) return lineDiscount.discount_application;
    }

    return null;
  }

  calculateTotalDiscount(cart, code) {
    if (!cart) return 0;
    const normalizedCode = code.toLowerCase();

    const cartDiscount = cart.cart_level_discount_applications?.find(
      discount => discount.title.toLowerCase() === normalizedCode
    );
    if (cartDiscount?.total_allocated_amount) {
      return cartDiscount.total_allocated_amount;
    }

    return (cart.items || []).reduce((total, item) => {
      const matchingAllocation = item.line_level_discount_allocations?.find(
        allocation => allocation.discount_application.title.toLowerCase() === normalizedCode
      );
      return total + (matchingAllocation?.amount || 0);
    }, 0);
  }

  getErrorMessage(error) {
    if (error.name === 'TypeError' || error.name === 'NetworkError') {
      return 'Network error. Please check your connection and try again.';
    }
    return 'Error applying discount code. Please try again.';
  }

  showConfirmDialog(message) {
    return new Promise(resolve => {
      const confirmed = window.confirm(message);
      resolve(confirmed);
    });
  }


  async handleRemove() {
    this.startTimer('handleRemove');
    try {
      this.startTimer('removeDiscount');
      const response = await fetch('/discount/clear');
      this.endTimer('removeDiscount');

      if (!response.ok) {
        throw new Error('Failed to remove discount');
      }

      window.cart.getCart();

      this.startTimer('fetchUpdatedCart');
      const updatedCart = await this.getCart();
      this.cartState = updatedCart;
      this.endTimer('fetchUpdatedCart');

      this.clearDiscount();
      // this.debug('Discount removed successfully');

    } catch (error) {
      // this.debug('Error removing discount', { error });
      console.error('Error removing discount:', error);
      this.showError('Error removing discount code');
    } finally {
      this.endTimer('handleRemove');
    }
  }

  // Rest of the methods remain the same, but with debug logging added
  async getCart() {
    this.startTimer('getCart');
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) {
        throw new Error('Failed to fetch cart');
      }
      const cart = await response.json();
      // this.debug('Cart fetched', { cart });
      return cart;
    } finally {
      this.endTimer('getCart');
    }
  }

  showSuccess(discount) {
    this.messageEl.textContent = 'Discount code applied successfully';
    this.messageEl.classList.add('is-success');

    this.valueEl.textContent = `${discount.title} (-${this.formatMoney(discount.amount)})`;
    this.appliedContainer.classList.add('is-visible');
  }

  showError(message) {
    this.messageEl.textContent = message;
    this.messageEl.classList.add('is-error');
  }

  clearMessage() {
    this.messageEl.textContent = '';
    this.messageEl.classList.remove('is-success', 'is-error');
  }

  clearDiscount() {
    this.clearMessage();
    this.valueEl.textContent = '';
    this.appliedContainer.classList.remove('is-visible');
  }

  setLoading(isLoading) {
    this.submitButton.classList.toggle('is-loading', isLoading);
    this.submitButton.disabled = isLoading;
  }

  formatMoney(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD'
    }).format(cents / 100);
  }

  checkUrlAndRestoreDiscount() {
    const url = new URL(window.location.href);
    const discountCode = url.searchParams.get('discount');

    if (discountCode) {
      this.input.value = discountCode;
      this.form.dispatchEvent(new Event('submit'));
    }
  }

  checkForExistingDiscount() {
    this.startTimer('checkForExistingDiscount');

    if (!this.cartState) return;

    // Check line-level discounts first
    const lineDiscount = this.cartState.items?.find(item =>
      item.line_level_discount_allocations?.some(
        allocation => allocation.discount_application.type === 'discount_code'
      )
    )?.line_level_discount_allocations?.find(
      allocation => allocation.discount_application.type === 'discount_code'
    )?.discount_application;

    // Check cart-level discounts if no line discount found
    const cartDiscount = this.cartState.cart_level_discount_applications?.find(
      discount => discount.type === 'discount_code'
    );

    const appliedDiscount = lineDiscount || cartDiscount;

    if (appliedDiscount) {
      // this.debug('Found existing discount', { discount: appliedDiscount });

      // Calculate total discount amount
      let totalDiscountAmount = 0;

      if (lineDiscount) {
        // Sum up all line discounts
        totalDiscountAmount = this.cartState.items.reduce((sum, item) => {
          const discountAmount = item.line_level_discount_allocations?.find(
            allocation => allocation.discount_application.type === 'discount_code'
          )?.amount || 0;
          return sum + discountAmount;
        }, 0);
      } else if (cartDiscount) {
        totalDiscountAmount = this.cartState.total_discount;
      }

      this.showSuccess({
        title: appliedDiscount.title,
        amount: totalDiscountAmount
      });

      this.lastAppliedCode = appliedDiscount.title;
    }

    this.endTimer('checkForExistingDiscount');
  }
}

customElements.define('cart-discount', CartDiscount);

class CalendarDropdown extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector('[data-calendar-trigger]');
    this.content = this.querySelector('.calendar-dropdown__content');

    if (this.trigger && this.content) {
      this.trigger.addEventListener('click', this.toggleDropdown.bind(this));
      document.addEventListener('click', this.handleClickOutside.bind(this));
    }
  }

  toggleDropdown(event) {
    event.preventDefault();
    const isHidden = this.content.hasAttribute('hidden');

    if (isHidden) {
      this.content.removeAttribute('hidden');
    } else {
      this.content.setAttribute('hidden', '');
    }
  }

  handleClickOutside(event) {
    if (!this.contains(event.target)) {
      this.content.setAttribute('hidden', '');
    }
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.handleClickOutside);
  }
}

customElements.define('calendar-dropdown', CalendarDropdown);


/**
 * Hacky-af but need to make sure I only impact custom code
 */
const injectKlaviyoForms = () => {
  const forms = document.querySelectorAll('[klaviyo\\:form]')

  forms.forEach(form => {
    const siteKey = form.getAttribute('klaviyo:form');
    const buttons = form.querySelectorAll('button[type="submit"]');

    /**
     * @param {SubmitEvent} e
     */
    const handleSubmit = async (e) => {
      e.preventDefault();
      const formData = new FormData(form);

      buttons.forEach(button => {
        button.classList.add('is-loading');
        button.disabled = true;
      });

      const [response] = await Promise.all([fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${siteKey}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          'Accept': 'application/vnd.api+json',
          'Revision': '2025-04-15'
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: form.getAttribute('klaviyo:source') ?? 'website',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: formData.get('email'),
                    locale: formData.get('locale'),
                    location: {
                      country: formData.get('country_code')
                    },
                    first_name: formData.get('first_name'),
                    subscriptions: {
                      email: {
                        marketing: {
                          consent: 'SUBSCRIBED'
                        }
                      }
                    }
                  },
                }
              }
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: form.getAttribute('klaviyo:list')
                }
              }
            }
          }
        })
      }), new Promise(res => setTimeout(res, 800))]);

      buttons.forEach(button => {
        button.classList.remove('is-loading');
        button.disabled = null;
      });

      if(response.status === 202) {
        form.classList.add('success');
      } else {
        buttons.forEach(button => {
          button.classList.add('error');

          setTimout(() => {
            button.classList.remove('error')
          }, 201);
        })
      }
    }

    form.addEventListener('submit', handleSubmit);
  })
}

injectKlaviyoForms();

// Viewport-based video autoplay system
class ViewportVideoAutoplay {
  constructor() {
    this.videos = new Map();
    this.observer = null;
    this.init();
  }

  init() {
    // Create intersection observer with 10% threshold
    this.observer = new IntersectionObserver(
      (entries) => this.handleIntersection(entries),
      {
        root: null,
        rootMargin: '50px',
        threshold: 0.1 // 10% threshold for smooth pause/play without customer noticing
      }
    );

    // Find and observe all videos with the data attribute
    this.observeVideos();

    // Watch for dynamically added videos
    this.watchForNewVideos();
  }

  observeVideos() {
    const videos = document.querySelectorAll('video[data-viewport-autoplay]');
    videos.forEach(video => {
      this.observer.observe(video);
      this.videos.set(video, { isPlaying: false });
    });
  }

  handleIntersection(entries) {
    entries.forEach(entry => {
      const video = entry.target;
      const videoData = this.videos.get(video);

      if (!videoData) return;

      if (entry.intersectionRatio >= 0.1) {
        // Video is 10% or more visible - start playing
        this.playVideo(video, videoData);
      } else {
        // Video is less than 10% visible - pause it
        this.pauseVideo(video, videoData);
      }
    });
  }

  async playVideo(video, videoData) {
    if (videoData.isPlaying) return;

    try {
      // Ensure video is ready for playback
      if (video.readyState > 0) {
        await video.play();
        videoData.isPlaying = true;
      } else {
        // Wait for video to be ready
        video.addEventListener('loadeddata', async () => {
          try {
            await video.play();
            videoData.isPlaying = true;
          } catch (error) {
            console.warn('Video autoplay failed:', error);
          }
        }, { once: true });
      }
    } catch (error) {
      // Autoplay failed (browser policy, user interaction required, etc.)
      console.warn('Video autoplay failed:', error);
    }
  }

  pauseVideo(video, videoData) {
    if (!videoData.isPlaying) return;

    try {
      video.pause();
      videoData.isPlaying = false;
    } catch (error) {
      console.warn('Video pause failed:', error);
    }
  }

  watchForNewVideos() {
    // Throttled mutation observer to reduce performance impact
    let mutationTimeout;
    const throttledHandler = (mutations) => {
      clearTimeout(mutationTimeout);
      mutationTimeout = setTimeout(() => {
        this.processMutations(mutations);
      }, 100); // Throttle to max 10 times per second
    };

    const mutationObserver = new MutationObserver(throttledHandler);

    // More targeted observation - only watch for specific changes
    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true,
      // Only observe additions/removals, not attribute changes
      attributes: false,
      characterData: false
    });

    // Store reference for cleanup
    this.mutationObserver = mutationObserver;
  }

  processMutations(mutations) {
    const addedVideos = [];
    const removedVideos = [];

    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        // Process added nodes
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            // Direct video check
            if (node.tagName === 'VIDEO' && node.hasAttribute('data-viewport-autoplay')) {
              addedVideos.push(node);
            }

            // Batch query for videos within added content
            if (node.querySelectorAll) {
              const videos = node.querySelectorAll('video[data-viewport-autoplay]');
              addedVideos.push(...videos);
            }
          }
        });

        // Process removed nodes
        mutation.removedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (node.tagName === 'VIDEO' && this.videos.has(node)) {
              removedVideos.push(node);
            }

            if (node.querySelectorAll) {
              const videos = node.querySelectorAll('video[data-viewport-autoplay]');
              videos.forEach(video => {
                if (this.videos.has(video)) {
                  removedVideos.push(video);
                }
              });
            }
          }
        });
      }
    });

    // Batch process changes
    addedVideos.forEach(video => {
      if (!this.videos.has(video)) {
        this.observer.observe(video);
        this.videos.set(video, { isPlaying: false });
      }
    });

    removedVideos.forEach(video => {
      this.observer.unobserve(video);
      this.videos.delete(video);
    });
  }

  // Public method to manually add video to observer
  addVideo(video) {
    if (video.tagName === 'VIDEO' && video.hasAttribute('data-viewport-autoplay')) {
      this.observer.observe(video);
      this.videos.set(video, { isPlaying: false });
    }
  }

  // Public method to manually remove video from observer
  removeVideo(video) {
    if (this.videos.has(video)) {
      this.observer.unobserve(video);
      this.videos.delete(video);
    }
  }

  // Cleanup method
  destroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
    }
    this.videos.clear();
  }
}

// Initialize the viewport video autoplay system
const viewportVideoAutoplay = new ViewportVideoAutoplay();

// Early Access Form Handler
function initEarlyAccessForms() {
  // First, process any queued events from inline handlers
  if (window.earlyAccessQueue && window.earlyAccessQueue.length > 0) {
    window.earlyAccessQueue.forEach(queuedEvent => {
      processEarlyAccessSubmission(queuedEvent);
    });
    // Clear the queue after processing
    window.earlyAccessQueue = [];
  }

  const forms = document.querySelectorAll('.early-access-form');

  if (!forms.length) return;

  forms.forEach(form => {
    const submitBtn = form.querySelector('.early-access-form__submit');
    const errorDiv = form.querySelector('.early-access-form__error');
    const sectionId = form.dataset.sectionId;
    const templateName = form.dataset.templateName;

    if (!submitBtn || !errorDiv) return;

    // Remove inline event handler if it exists
    if (form.hasAttribute('onsubmit')) {
      form.removeAttribute('onsubmit');
    }

    form.addEventListener('submit', async function(e) {
      e.preventDefault();

      const formData = new FormData(form);
      const code = formData.get('code');

      const eventData = {
        form: form,
        code: code,
        submitBtn: submitBtn,
        errorDiv: errorDiv,
        sectionId: sectionId,
        templateName: templateName,
        timestamp: Date.now()
      };

      await processEarlyAccessSubmission(eventData);
    });
  });
}

// Shared function to process early access submissions
async function processEarlyAccessSubmission(eventData) {
  const { form, code, submitBtn, errorDiv, sectionId, templateName } = eventData;
  const wrapper = form.closest('[data-gated-content]');

  if (!code) {
    submitBtn.classList.remove('is-loading');
    submitBtn.disabled = false;
    return;
  }

  // Reset messages
  errorDiv.style.display = 'none';

  // Show loading state
  submitBtn.classList.add('is-loading');
  submitBtn.disabled = true;

  try {
    const response = await fetch('/a/internal/early-access', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        code: code
      })
    });

    if (response.status === 200) {
      const url = new URL(window.location.href);

      if(templateName === 'product') {
        url.searchParams.set('view', 'product');
      }

      url.searchParams.set('section_id', sectionId);

      const data = await fetch(url.toString()).then(r => r.text())
      const section = form.closest('.shopify-section');

      const formWrapper = section.querySelector('[data-form-wrapper]');
      const newSection = document.createElement('div')

      newSection.innerHTML = data;

      const replacementForm = newSection.querySelector('[data-form-wrapper]');

      if(formWrapper && replacementForm) {
        formWrapper.parentElement.insertBefore(replacementForm, formWrapper);
        formWrapper.remove();
      }

      wrapper.remove();

      await fetch(`${window.theme.routes.cart_url}/update.js`, {
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify({
          attributes: {
            '_early-access': code
          },
          discount: code
        })
      });
    } else if (response.status === 425) {
      errorDiv.textContent = 'Too early — come back at 7pm CEST';
      errorDiv.style.display = 'block';
    } else if (response.status === 404) {
      // Code not found
      errorDiv.textContent = 'Invalid access code. Please try again.';
      errorDiv.style.display = 'block';
    } else {
      // Other error
      errorDiv.textContent = 'An error occurred. Please try again.';
      errorDiv.style.display = 'block';
    }
  } catch (error) {
    // Network error
    errorDiv.textContent = 'Network error. Please try again.';
    errorDiv.style.display = 'block';
  } finally {
    // Remove loading state
    submitBtn.classList.remove('is-loading');
    submitBtn.disabled = false;
  }
}

// Initialize early access forms
initEarlyAccessForms();
